import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu May 30 2019
 * @author Tomáš Leity
 */
import { bigdecimal } from '@logio/big-decimal';
import * as React from 'react';
import { InputValidated } from '../../../../inputs/Input';
import CellEditor from './CellEditor';
/**
 * Percentage editor for the AgGrid
 * @extends CellEditor
 */

var PercentageEditor =
/*#__PURE__*/
function (_CellEditor) {
  _inherits(PercentageEditor, _CellEditor);

  function PercentageEditor(props) {
    var _this;

    _classCallCheck(this, PercentageEditor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PercentageEditor).call(this, props));
    /**
     * Handles changes of the input element
     */

    _this.onChange = function (event) {
      // This one works because TS strictNullCheck is switched off by default
      _this.updateValue(event.target.value !== '' ? bigdecimal(event.target.valueAsNumber) : null);
    };
    /**
     * LOG-2079 - Select all on focus
     */


    _this.onFocus = function (event) {
      event.target.select();
    };

    _this.render = function () {
      return React.createElement("div", {
        ref: _this.wrapper
      }, React.createElement(InputValidated, {
        validationError: _this.state.validationError,
        type: "number",
        value: _this.state.value ? _this.state.value.toNumber() : '',
        onChange: _this.onChange,
        onFocus: _this.onFocus,
        className: "ag-cell-editor",
        tiny: true
      }));
    };

    _this.state = _this.initialState(_this.props.value ? _this.props.value.times(100) : null);
    return _this;
  }

  return PercentageEditor;
}(CellEditor);

export { PercentageEditor as default };